import React from 'react';

import './AffiliateInfoApp.scss';
import DATA from './data.js';

import Caret from '../../../../assets/images/svgs/elocal-caret.svg';
import CaretActive from '../../../../assets/images/svgs/elocal-caret-selected.svg';
import WhyIcon from '../../../../assets/images/svgs/oval-line.svg';

const AffiliateInfoApp = () => {
  const [state, setState] = React.useState(0);
  return (
    <div className="why-container">
      <div className="affiliate-container">
        <h2>Why Become An Elocal Affiliate</h2>
        <dl className="why-selector-container">
          {DATA.map((item, i) => (
            <React.Fragment key={item.label}>
              <dt
                onClick={() => setState(i)}
                className={state === i ? 'active' : null}
              >
                <img src={state === i ? CaretActive : Caret} />
                {item.label}
              </dt>
              <dd className={state === i ? 'active' : null}>
                <strong>
                  <img src={WhyIcon} />
                  <span>{item.label}</span>
                </strong>
                <p>{item.content}</p>
              </dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default AffiliateInfoApp;
